import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import Button from './Button';
import Card from './Card';
import TeamTable from './TeamTable';
import { GET_ORGANIZATION_ROLES } from '../graphql/queries';
import Loader from './Loader';
import BaseModal, { ModalList } from './modals/BaseModal';

const Wrapper = styled.div`
width: 80%;

@media (max-width:991px){
  width: 100%;
}
`;

const LoaderContainer = styled.div`
  /* position: absolute;
  top: calc(50vh - 60px);
  left: calc(50vw - 60px); */
  height: calc(60vh - 60px);
  width: calc(100vw - 60px);
  justify-content:center;
  align-items: center;
  display: flex;
`;

export default function Team() {
  const { data, loading } = useQuery(GET_ORGANIZATION_ROLES);
  const [modalIsVisible, setModalIsVisible] = useState(false);

  if (loading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  return (
    <Wrapper>
      <Card width="100%" padding="20px 30px">
        <div style={{ display: 'flex', flexDirection: 'column' }}>

          <BaseModal
            open={modalIsVisible}
            modalType={ModalList.AddTeamMemberModal}
            onClose={setModalIsVisible}
          />
          <Button
            margin="40px 0px"
            text="ADD TEAM MEMBER"
            type="button"
            width="fit-content"
            onClick={() => setModalIsVisible(true)}
          />
          <TeamTable roles={data.getOrganizationRoles} />
        </div>
      </Card>
    </Wrapper>
  );
}
